<div class="tw-text-center tw-text-muted">
  <p bitTypography="body2" class="tw-mb-0">
    {{ "sendAccessTaglineProductDesc" | i18n }}
    {{ "sendAccessTaglineLearnMore" | i18n }}
    <a bitLink routerLink="/signup" target="_blank" rel="noreferrer">{{
      "sendAccessTaglineProductName" | i18n
    }}</a>
    {{ "sendAccessTaglineOr" | i18n }}
    <a bitLink routerLink="/signup" target="_blank" rel="noreferrer">{{
      "sendAccessTaglineSignUp" | i18n
    }}</a>
    {{ "sendAccessTaglineTryToday" | i18n }}
  </p>
</div>
